import {CandidateSource, QuizCandidate} from '../types';

/** Strict tier order (not a weighted score) — see README.md. */
const TIER_ORDER: CandidateSource[] = ['requiz', 'refresher', 'default'];

/**
 * Groups the pool into requiz > refresher > default tiers, in that strict order.
 */
export function rankCandidates(pool: QuizCandidate[]): QuizCandidate[] {
    return TIER_ORDER.flatMap((source) => pool.filter((candidate) => candidate.source === source));
}

/**
 * Returns the top-ranked candidate not present in `excludedIds`, or `null` if the pool
 * is exhausted. A "Show me another" skip re-runs this with the skipped quiz ID added.
 */
export function selectNextCandidate(
    pool: QuizCandidate[],
    excludedIds: ReadonlySet<number>,
): QuizCandidate | null {
    const ranked = rankCandidates(pool);
    return ranked.find((candidate) => !excludedIds.has(candidate.quizId)) ?? null;
}
